/* eslint-disable @typescript-eslint/strict-boolean-expressions */

import { formatCurrency } from "../../utils/currencyFormatter";
import { Box, Typography } from "@mui/material";
import { ISummaryContent } from "../../modules/financial/models/GetAllNfeDTO";
import { DateToFormat } from "../../utils/dateFormatter";

export const TableSummary = ({
  data,
}: {
  data: ISummaryContent | null | undefined;
}) => {
  if (!data || !data.period) return null;

  const dateStart = data.period.begin ? DateToFormat(data.period.begin) : "-";
  const dateEnd = data.period.end ? DateToFormat(data.period.end) : "-";

  return (
    <Box sx={{ mb: 1, p: 1 }}>
      <Typography sx={{ fontSize: 14, color: "text.primary" }}>
        Exibindo <strong>{data.totalRecords ?? 0}</strong> resultados, valor
        total de <strong>{formatCurrency(data.totalValue ?? 0)}</strong> no
        período de <strong>{dateStart}</strong> até <strong>{dateEnd}</strong>
      </Typography>
    </Box>
  );
};
